import { Directive, ElementRef, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { isNullOrUndefined } from 'util';

@Directive({
  selector: 'a[appExternalUrl]'
})
export class ExternalUrlDirective {

  constructor(private el: ElementRef, private router: Router) { }

  /**
   * Generic directive for external URLs using Angular routing to enable use of authguards, etc.
   * @param event clicky-clacky
   */
  @HostListener('click', ['$event'])
  clicked(event: Event) {
    const url = this.el.nativeElement.href;
    if (isNullOrUndefined(url)) {
      return;
    }

    this.router.navigate(['/externalRedirect', { externalUrl: url }], {
      skipLocationChange: true
    });

    event.preventDefault();
  }
}
